export enum OrderKind {
  Offer = 0,
  Sale = 1
}

export enum TokenStandard {
  ERC20 = 0,
  ERC721,
  ERC1155
}

export const EXCHANGE_FEE_MULTIPLIER = 1.013
